import Bodymovin from './bodymovin'
import React, {Component} from 'react'
import PropTypes from 'prop-types'

class BodymovinSegments extends Component {

	constructor() {
		super()
		this.setElement = this.setElement.bind(this)
	}

	setElement(elem) {
		this.bm_elem = elem
	}

	componentDidMount() {
		this.segments = this.props.segments
		if (this.props.segments && this.props.segments['init']) {
			setTimeout(function() {
				if (this.props.segment === 'init' && this.bm_elem) {
					this.bm_elem.playSegments(this.props.segments['init'].segment, true)
					this.bm_elem.loop(this.props.segments['init'].loop)
					this.bm_elem.setSpeed(this.props.segments['init'].speed || 1)
				}
			}.bind(this), this.props.delay)
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (!this.bm_elem) {
			return
		}
		if (nextProps.segment !== this.props.segment && this.props.segments[nextProps.segment]) {
			this.bm_elem.playSegments(this.props.segments[nextProps.segment].segment, true)
			this.bm_elem.loop(this.props.segments[nextProps.segment].loop)
			this.bm_elem.setSpeed(this.props.segments[nextProps.segment].speed || 1)
		}
	}

	render() {
		return (
			<Bodymovin
				ref={this.setElement}
				animationData={this.props.animationData}
				autoplay={false}
				{...this.props.settings}
				listeners={this.props.listeners}
			>
				{this.props.children}
			</Bodymovin>
		)
	}
}
BodymovinSegments.propTypes = {
	settings: PropTypes.object,
	children: PropTypes.node,
	animationData: PropTypes.object,
	listeners: PropTypes.object,
	segments: PropTypes.object,
	segment: PropTypes.string,
	delay: PropTypes.number,
}

BodymovinSegments.defaultProps = {
	delay: 0,
	segment: 'init',
	settings: {},
}

export default BodymovinSegments
